export default "__VITE_ASSET__BMokDCzu__"